import script from "./RichTextMediaDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextMediaDialog.vue?vue&type=script&setup=true&lang=js"

import "./RichTextMediaDialog.vue?vue&type=style&index=0&id=196505fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196505fa"]])

export default __exports__